import { useMutation, useQueryClient } from '@tanstack/react-query';
import { adminServices } from 'features/admin/services/admin.service';

import { toast } from 'react-hot-toast';

export const useCreateAdmin = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (adminData) => adminServices.addAdmin(adminData),
    onSuccess: () => {
      queryClient.invalidateQueries(['admins']);
      toast.success('Admin created successfully');
    },
    onError: (error) => {
      toast.error(
        error?.response?.data?.errors?.[0]?.message ||
          error?.response?.data?.message ||
          "Failed to create admin",
      );
    },
  });
};

export const useUpdateAdmin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ adminId, adminData }) => adminServices.updateAdmin(adminId, adminData),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(['admins']);
      queryClient.invalidateQueries(['admins', variables.adminId]);
      toast.success('Admin updated successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update admin');
    },
  });
};

export const useDeleteAdmin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (adminId) => adminServices.deleteAdmin(adminId),
    onSuccess: () => {
      queryClient.invalidateQueries(['admins']);
      toast.success('Admin deleted successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to delete admin');
    },
  });
};

export const useToggleAdminStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (adminId) => adminServices.toggleAdminStatus(adminId),
    onSuccess: () => {
      queryClient.invalidateQueries(['admins']);
      toast.success('Admin status updated successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to update admin status');
    },
  });
};
